import { faShapes } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  BackButton,
  Container,
  Page,
  PageTitle,
} from '@foxtrotplatform/developer-platform-common-ui-component-lib';
import { useOrganization } from '@foxtrotplatform/platform-micro-site-core';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { RequireUserTeam } from '../../common/auth/RequireTeam';
import {
  DeveloperOrganizationContextProps,
  TenantOnboardingStatus,
} from '../../common/providers/types';

export const ApplicationRoot: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const { isOrganizationsReady, requiresOrgOnboarding, currentTenant } =
    useOrganization() as DeveloperOrganizationContextProps;

  React.useEffect(() => {
    if (isOrganizationsReady && requiresOrgOnboarding) {
      navigate('/organization');
    } else if (
      currentTenant &&
      currentTenant.onboardingStatus === TenantOnboardingStatus.SUCCESS
    ) {
      navigate(`/application`, { replace: true });
    }
  }, [requiresOrgOnboarding, isOrganizationsReady, currentTenant]);

  return (
    <RequireUserTeam>
      <Page>
        <Container className="flex flex-col" size="medium">
          <div className="flex flex-row items-center gap-x-3">
            <BackButton />
            <PageTitle>Apps</PageTitle>
          </div>
          <div className="flex flex-col items-center">
            <div className="flex flex-row justify-around items-center h-16 w-16">
              <FontAwesomeIcon className="h-12 w-12" icon={faShapes} />
            </div>
            <div className="pt-os1-spacing">
              <span className="text-sm text center">
                You need to have a sandbox tenant to register an app with us. We
                are reviewing your request for the sandbox tenant. Our admins
                will reach out to you with a decision shortly.
              </span>
            </div>
          </div>
        </Container>
      </Page>
    </RequireUserTeam>
  );
};
